import styled from 'styled-components'

import { ClinTable } from '../../../components/ClinTable'
import { StyledClinChip } from '../../../components/ClinChip/ClinChip.styles'
import { StyledClinTableOrderToggle } from '../../../components/ClinTableOrderToggle/ClinTableOrderToggle.styles'

export const StyledUkShortages = styled.div({
  [`${StyledClinTableOrderToggle}`]: {
    whiteSpace: 'nowrap'
  },
  [`.shortages__alternative-name`]: {
    textDecoration: 'underline',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    display: 'block'
  },
  [`.shortages__form-pack-size`]: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    [`${StyledClinChip}`]: {
      maxWidth: '100%',
      whiteSpace: 'normal',
      wordBreak: 'break-word',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: 'inline-flex',
      flexWrap: 'wrap',
      margin: '0',
      '& > *': {
        whiteSpace: 'normal',
        wordBreak: 'break-word'
      }
    }
  }
})

export const StyledClinTable = styled(ClinTable)`
  width: 100%;
  max-width: 100%;

  & > div {
    overflow-x: visible !important;
    overflow-y: auto;
  }

  table {
    width: 100%;
    table-layout: fixed;
  }

  th {
    overflow: hidden;
    word-wrap: break-word;
  }

  td {
    overflow: hidden;
    text-overflow: ellipsis;
    word-wrap: break-word;
  }
`

export const StyledNoShortagesMessage = styled.div({
  textAlign: 'center',
  svg: {
    width: 150,
    height: 150
  },
  p: {
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  [`.no-shortages-message__instructions`]: {
    maxWidth: 380
  }
})
